module.exports = __webpack_public_path__ + "static/lake_aerial_3-76b1356515efe6224f0ff0ab020f9345.jpg";